module.exports = __webpack_public_path__ + "img/multiplier.4638b70f.png";